module.exports = __webpack_public_path__ + "static/media/empty-factory.747a5adc.webm";